import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_event-truck/artifacts/97dej6rv_Um%20Ulm%20Events%20White%20logo%202400x1800.jpeg" 
              alt="Um Ulm Events" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              Professionelles Eventcatering & Food Truck Service seit 2017
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-red-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/food-trucks" className="text-gray-400 hover:text-red-500 transition-colors">
                  Food Trucks
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-gray-400 hover:text-red-500 transition-colors">
                  Events & Galerie
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-red-500 transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Food Truck Catering</li>
              <li>Cocktail & Getränkebars</li>
              <li>VW T2 Photobus</li>
              <li>Bühnenprogramme</li>
              <li>Event-Equipment</li>
              <li>Servicepersonal</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <span>Ulm & Umgebung<br />Baden-Württemberg</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0" />
                <span>+49 173 6338684</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <Mail className="w-5 h-5 text-red-500 flex-shrink-0" />
                <span>info@umulmevents.de</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.facebook.com/profile.php?id=61551866321150" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-full hover:bg-red-600 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/umulmevents/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-full hover:bg-red-600 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {currentYear} Um Ulm Events. Alle Rechte vorbehalten.</p>
          <div className="mt-2 space-x-4">
            <Link to="/impressum" className="hover:text-red-500 transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-red-500 transition-colors">
              Datenschutz
            </Link>
            <Link to="/agb" className="hover:text-red-500 transition-colors" data-testid="footer-agb-link">
              AGB
            </Link>
            <button
              onClick={() => window.openCookieSettings && window.openCookieSettings()}
              className="hover:text-red-500 transition-colors"
              data-testid="footer-cookie-settings-btn"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;